// Comprime en canvas: redimensiona al lado mayor dado y reexporta como JPEG a la calidad dada.
// Los HEIC de iPhone no los puede leer `new Image()` en Chrome/Edge: se convierten antes con
// heic-to (import dinámico, para no sumar su parser al bundle inicial).

function esHeic(file) {
  const tipo = (file.type || "").toLowerCase();
  const nombre = (file.name || "").toLowerCase();
  return tipo === "image/heic" || tipo === "image/heif" || nombre.endsWith(".heic") || nombre.endsWith(".heif");
}

// file.type puede venir vacío para un HEIC (depende del navegador/SO), así que no basta con
// el filtro "image/*" de siempre.
export function esImagen(file) {
  return (file.type || "").startsWith("image/") || esHeic(file);
}

// En celulares se deja "image/*" para no romper la apertura directa de la cámara; en
// escritorio (donde un HEIC llega por selector de archivos, no por cámara) se acepta además
// por extensión, porque algunos navegadores no le ponen `type` a un .heic/.heif.
export const ACCEPT_IMAGEN = /Android|iPhone|iPad/i.test(navigator.userAgent) ? "image/*" : "image/*,.heic,.heif";

// FotosTrabajo llama comprimirImagen() dos veces (foto + miniatura) con el MISMO File; no
// hay que convertir el HEIC dos veces, así que la promesa de conversión se cachea por file.
const _conversionesHeic = new WeakMap();

function convertirSiHeic(file) {
  if (!esHeic(file)) return Promise.resolve(file);
  if (_conversionesHeic.has(file)) return _conversionesHeic.get(file);
  const promesa = import("heic-to")
    .then(({ heicTo }) => heicTo({ blob: file, type: "image/jpeg", quality: 0.95 }))
    .catch(() => {
      throw new Error("No se pudo convertir esta foto HEIC; expórtela como JPEG y vuelva a subirla");
    });
  _conversionesHeic.set(file, promesa);
  return promesa;
}

export function comprimirImagen(file, ladoMayor, calidad) {
  return convertirSiHeic(file).then((fuente) => new Promise((resolve, reject) => {
    const img = new window.Image();
    const url = URL.createObjectURL(fuente);
    img.onload = () => {
      let { width, height } = img;
      const max = Math.max(width, height);
      if (max > ladoMayor) {
        const escala = ladoMayor / max;
        width = Math.round(width * escala);
        height = Math.round(height * escala);
      }
      const canvas = document.createElement("canvas");
      canvas.width = width; canvas.height = height;
      canvas.getContext("2d").drawImage(img, 0, 0, width, height);
      canvas.toBlob((blob) => {
        URL.revokeObjectURL(url);
        if (blob) resolve(blob); else reject(new Error("No se pudo procesar la imagen"));
      }, "image/jpeg", calidad);
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("No se pudo leer la imagen")); };
    img.src = url;
  }));
}
